import React, { useState } from "react";
import { AuthContext } from "../../AuthContext";
import { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import axios from "axios";
import { useContext } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function SignUp2() {
  const [showPass, setShowPass] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    contactNo: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = "Full Name is required.";
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Valid Email is required.";
    if (!/^[6-9]\d{9}$/.test(formData.contactNo))
      newErrors.contactNo = "Enter a valid 10-digit Indian mobile number.";
    if (formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters long.";
    if (formData.password !== formData.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "contactNo") {
      if (!/^\d*$/.test(value)) return; 
    }
  
    setFormData({ ...formData, [name]: value });
  };

const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e) => {
  e.preventDefault();

  if (validateForm()) {
    setIsSubmitting(true); // Disable the button

    try {
      const submissionData = {
        Named: formData.fullName,
        Email: formData.email,
        Cno: formData.contactNo,
        Jdate: new Date().toISOString().split("T")[0],
        Pass: formData.password,
      };

      const response = await axios.post(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/registerastrologeremail",
        submissionData
      );

      if (response.data.success) {
        login(response.data.token);
        localStorage.setItem("astrologerId", response.data.astrologerId);
        window.location.href = "/astrologerdashboard";

        setFormData({
          fullName: "",
          email: "",
          contactNo: "",
          password: "",
          confirmPassword: "",
        });
      } else {
         toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
       toast.error("An error occurred while submitting the form.");
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  }
};
  const { login } = useContext(AuthContext);
  return (
    <section className="account-section" style={{
      backgroundImage: `url(${require("../../assets/siteimages/astrobackground2245.png")})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh", // full screen height
    }}>
      <div className="tf-container">
        <div className="row">
          <Tabs className="wd-form-login tf-tab">
          <h5 style={{fontSize:"32px"}}>Create Astrologer Account</h5>
          <p style={{marginBottom:"20px"}}>Use the following form to create a new account with us.</p>
           
             <TabList className="menu-tab">
                         <NavLink to="/astrologerreg" className="ct-tab" style={{width:"100%"}}>
                           <Tab style={{width:"100%"}}>Astrologer</Tab>
                         </NavLink>
                         <NavLink to="/registration" className="ct-tab"  style={{width:"100%"}}>
                           <Tab style={{width:"100%"}}>New User</Tab>
                         </NavLink>
                       </TabList>
            <div className="content-tab">
              <TabPanel className="inner animation-tab">
             
              <form onSubmit={handleSubmit}>
                  <div className="ip">
                    <label style={{ fontWeight: "bold" }}>Full Name&nbsp;<span>*</span></label>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="Full Name"
                      style={{ backgroundColor: "#fafafa" }}
                    />
                    {errors.fullName && <p className="error">{errors.fullName}</p>}
                  </div>

                  <div className="ip">
                    <label style={{ fontWeight: "bold" }}>Email address&nbsp;<span>*</span></label>
                    <input
                      type="text"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Email Address"
                      style={{ backgroundColor: "#fafafa" }}
                    />
                    {errors.email && <p className="error">{errors.email}</p>}
                  </div>

                  <div className="ip">
                    <label style={{ fontWeight: "bold" }}>Contact No.&nbsp;<span>*</span></label>
                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                    <span style={{ position: "absolute", left: "15px", color: "#555", fontWeight:"bold" }}>+91</span>
                    <input
  type="text"
  name="contactNo"
  value={formData.contactNo}
  onChange={handleChange}
  inputMode="numeric"
  pattern="\d*"
  maxLength="10"
  placeholder="Contact No."
  style={{ backgroundColor: "#fafafa", paddingLeft:"50px" }}
/>
</div>
                    {errors.contactNo && <p className="error">{errors.contactNo}</p>}
                  </div>

                  <div className="ip">
                    <label style={{ fontWeight: "bold" }}>Create Password&nbsp;<span>*</span></label>
                    <div className="inputs-group auth-pass-inputgroup">
                      <input
                        type={showPass ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="New Password"
                        className="input-form password-input"
                        style={{ backgroundColor: "#fafafa" }}
                      />
                      <Link
                        className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"}`}
                        onClick={() => setShowPass(!showPass)}
                      />
                    </div>
                    {errors.password && <p className="error">{errors.password}</p>}
                  </div>

                  <div className="ip">
                    <label style={{ fontWeight: "bold" }}>Confirm Password&nbsp;<span>*</span></label>
                    <div className="inputs-group auth-pass-inputgroup">
                      <input
                        type={showPass2 ? "text" : "password"}
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        placeholder="Confirm Password"
                        className="input-form password-input"
                        style={{ backgroundColor: "#fafafa" }}
                      />
                      <Link
                        className={`password-addon ${showPass2 ? "icon-eye" : "icon-eye-off"}`}
                        onClick={() => setShowPass2(!showPass2)}
                      />
                    </div>
                    {errors.confirmPassword && <p className="error">{errors.confirmPassword}</p>}
                  </div>
                  
                  <button type="submit" disabled={isSubmitting}>
  {isSubmitting ? "Please Wait..." : "Register With Us"}
</button>
                   <div className="group-ant-choice" style={{marginTop:"15px", textAlign:"center"}}>
                                                <div className="sub-ip" style={{margin:"auto"}}>
                                                
                                  Registered Already? <Link to="/astrologerlogin">Continue As Astrologer</Link>
                               
                                                </div>
                                              </div>
                </form>
           <style>
          {`
            .Toastify__close-button {
              display: none;
            }
          
            .Toastify__toast {
              position: relative;
              padding-right: 30px;
            }
          `}
          </style>
                     <ToastContainer position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover />
              </TabPanel>
            </div>
          </Tabs>
        </div>
      </div>
    </section>
  );
}

export default SignUp2;
